module.exports = __webpack_public_path__ + "static/media/tucson_team.c69de8ac.jpg";